'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/taxonomies/taxonomies.controller'
],function(angular,TaxonomiesCtrl){
    var app=angular.module('app.seospider.exam.analysis.taxonomies', []);

    app.controller('TaxonomiesCtrl',TaxonomiesCtrl);
    return app;
});